/* eslint class-methods-use-this:0 */

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Page from '../../../../shared/components/Page';
import PageContent from '../../../../shared/components/PageContent';
import PageHeader from '../../../../shared/components/PageHeader';
import { makeGetObjectsFromStateById } from '../../../../shared/selectors';
import DimensionsTable from './DimensionsTable';

import { getManyDimensions } from '../../../../shared/actions/index';
import { RuntimeContext } from '../../../../../common/RuntimeContext';

class ManageContentFramework extends Component {
    static propTypes = {
        getManyDimensions: PropTypes.func,
        history: PropTypes.object,
        dimensions: PropTypes.array
    };

    static contextType = RuntimeContext

    componentDidMount() {
        return this.props.getManyDimensions({ getFullObjects: true, pathsContext: this.context.pathsWeb });
    }

    render() {
        const { dimensions = [], history } = this.props;

        return (
            <Page className={'manage-content-framework'}>
                <PageHeader title={'Dimensions'} className={'adminTableHeaderTabs adminPageHeader'} hideBackButton={true} />
                <PageContent className={'manageTrackWrapper adminWrapper container'}>
                    <DimensionsTable dimensions={dimensions} history={history} />
                </PageContent>
            </Page>
        );
    }
}

export const mapStateToProps = () => {
    const getDimensionsFromState = makeGetObjectsFromStateById('dimensions');
    const derivedMapStateToProps = (state) => {
        const {
            auth: { loggedInUser }
        } = state;

        const allDimensions = getDimensionsFromState(state);

        return {
            currentUser: loggedInUser,
            dimensions: allDimensions || []
        };
    };

    return derivedMapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
    getManyDimensions: (params) => dispatch(getManyDimensions(params))
});

export const ManageContentFrameworkComponent = ManageContentFramework;
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageContentFramework));
